import { ConcurrentExperience, UFOExperience, ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo';
import { withSampling } from '@atlaskit/emoji';

/**
 * Initial experience config object (deferred from @atlaskit/ufo inner types)
 */

/**
 * Helper method for create the config type for an individual/Concurrent experience
 * @param componentName
 */
var createExperienceConfig = function createExperienceConfig(componentName, type, performanceType) {
  return {
    platform: {
      component: componentName
    },
    type: type,
    performanceType: performanceType
  };
};

/**
 * Types of experiences
 */
export var ExperienceName = /*#__PURE__*/function (ExperienceName) {
  ExperienceName["REACTIONS_RENDERED"] = "reactions-rendered";
  ExperienceName["PICKER_OPENED"] = "reactions-picker-opened";
  ExperienceName["REACTION_ADDED"] = "reaction-added";
  ExperienceName["REACTION_REMOVED"] = "reaction-removed";
  ExperienceName["REACTION_DETAILS_FETCHED"] = "reaction-details-fetched";
  ExperienceName["REACTION_DIALOG_OPENED"] = "reaction-dialog-opened";
  ExperienceName["REACTION_DIALOG_CLOSED"] = "reaction-dialog-closed";
  ExperienceName["REACTION_DIALOG_SELECTED_REACTION_CHANGED"] = "reaction-dialog-selected-reaction-changed";
  return ExperienceName;
}({});

/**
 * UFO types of components been instrumented
 */
export var ComponentName = /*#__PURE__*/function (ComponentName) {
  ComponentName["PICKER_RENDERED"] = "reactions-picker";
  ComponentName["REACTIONS"] = "reactions-list";
  ComponentName["REACTION_ITEM"] = "reaction-item";
  ComponentName["REACTION_DIALOG"] = "reaction-dialog";
  return ComponentName;
}({});

/**
 * Experience when the emoji picker is opened
 */
export var PickerRender = new UFOExperience(ExperienceName.PICKER_OPENED, createExperienceConfig(ComponentName.PICKER_RENDERED, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Experience when the list of reactions gets rendered
 */
export var ReactionsRendered = new ConcurrentExperience(ExperienceName.REACTIONS_RENDERED, createExperienceConfig(ComponentName.REACTIONS, ExperienceTypes.Load, ExperiencePerformanceTypes.PageSegmentLoad));

/**
 * Experience when a reaction emoji gets added
 */
export var ReactionsAdd = new ConcurrentExperience(ExperienceName.REACTION_ADDED, createExperienceConfig(ComponentName.REACTIONS, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Expeirence when a reaction dialog is opened
 */
export var ReactionDialogOpened = new UFOExperience(ExperienceName.REACTION_DIALOG_OPENED, createExperienceConfig(ComponentName.REACTION_DIALOG, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Experience when a reaction dialog is closed
 */
export var ReactionDialogClosed = new UFOExperience(ExperienceName.REACTION_DIALOG_CLOSED, createExperienceConfig(ComponentName.REACTION_DIALOG, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Experience when a reaction changed/fetched from inside the modal dialog
 */
export var ReactionDialogSelectedReactionChanged = new UFOExperience(ExperienceName.REACTION_DIALOG_SELECTED_REACTION_CHANGED, createExperienceConfig(ComponentName.REACTION_DIALOG, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Experience when a reaction details gets fetched
 */
export var ReactionDetailsFetch = new ConcurrentExperience(ExperienceName.REACTION_DETAILS_FETCHED, createExperienceConfig(ComponentName.REACTION_ITEM, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));

/**
 * Experience when a reaction emoji gets removed/decrement
 */
export var ReactionsRemove = new ConcurrentExperience(ExperienceName.REACTION_REMOVED, createExperienceConfig(ComponentName.REACTIONS, ExperienceTypes.Experience, ExperiencePerformanceTypes.InlineResult));
export var sampledReactionsRendered = function sampledReactionsRendered(instanceId) {
  return withSampling(ReactionsRendered.getInstance(instanceId));
};